export const baseUrl = import.meta.env.VITE_API_URL || 'Fallback-URL'
export const baseUrlIdent = import.meta.env.VITE_IDENT_URL || 'Fallback-URL'
export const protectedResources = {
  apiList: {
    createOrUpdateDashboard: baseUrl + '/dashboard/createOrUpdate',
    deleteDashboard: baseUrl + '/dashboard/delete',
    readDashboard: baseUrl + '/dashboard/read',

    readSalutation: baseUrl + '/salutation/read',

    readTitles: baseUrl + '/title/read',

    readEvent: baseUrl + '/event/read',
    readEventParticipants: baseUrl + '/event/readParticipantList',
    readDocTemplate: baseUrl + '/event/readDocTemplate',

    readFileTypes: baseUrl + '/Setting/FileTypes',

    readProfile: baseUrl + '/profile/read',
    createOrUpdateProfile: baseUrl + '/profile/CreateOrUpdate',
    createOrUpdateDocent: baseUrl + '/Profile/CreateOrUpdateDocent',

    createFile: baseUrl + '/File/save',
    readFiles: baseUrl + '/File/read',
    readFileContent: baseUrl + '/File/readFile',
    deleteFile: baseUrl + '/File/delete',

    readAllDocent: baseUrl + '/Docent/read/all',
    readRequestedDocent: baseUrl + '/Docent/read/requested',
    readDocentByAdrNo: baseUrl + '/Docent',

    readTopicAreas: baseUrl + '/Setting/ReadTopicsAreas',

    readInstructors: baseUrl + '/Setting/ReadInstructors',

    videoUpload: baseUrl + '/Upload/save',
    videoUploadRemove: baseUrl + '/Upload/remove',
  },
}

export const appRoles = {
  Teilnehmer: 'Teilnehmer',
  Kunde: 'Kunde',
  Dozent: 'Dozent',
  Intern: 'Intern',
  Anonym: 'Anonym',
}

import { TokenRenewMode } from '@axa-fr/react-oidc'

export const configurationIdentityServer = {
  client_id: '5f5f361a-b6bd-44f3-82de-73e40bb02c52',
  redirect_uri: window.location.origin + '/#authentication-callback',
  silent_redirect_uri: window.location.origin + '/#silent-callback',
  silent_login_uri: window.location.origin + '/#silent-login',
  scope: 'openid profile skoruba_identity_admin_api email roles offline_access dozent_portal_api',
  authority: import.meta.env.VITE_IDENT_URL,
  refresh_time_before_tokens_expiration_in_second: 40,
  //service_worker_relative_url: './OidcServiceWorker.js',
  service_worker_only: false,
  monitor_session: true,
  token_renew_mode: TokenRenewMode.access_token_invalid,
}
